class CookieStorage implements IStorage {
    constructor() {
        throw new Error("Not implemented yet");
    }

    public update(key: string, fieladKey: string, value:string) {
        
    }
    public save(key: string, value: string) {
        
    }
    public get(key: string) {
        return "";
    }
    public delete(key: string) {

    }
}